import { PostSaleLineItems } from '../types/postSale';

export interface ITradeListPaymentsOnHold {
  id: number;
  make: string;
  model: string;
  trim: string;
  thumbnailUrl: string;
  year: number;
  vin: string;
  topBid: number;
  bidPlacedTime: string;
  onHoldStatuses: object[];
}

class TradeListPaymentsOnHold {
  tradeSummaries: ITradeListPaymentsOnHold[];

  constructor(data: any = []) {
    this.tradeSummaries = data ? TradeListPaymentsOnHold.mapTrades(data) : [];
  }

  private static mapTrades(trades: any = []): ITradeListPaymentsOnHold[] {
    return trades.map(t => ({
      id: t.tradeResponse.tradeId,
      make: t.tradeResponse.make?.displayName,
      model: t.tradeResponse.model?.displayName,
      trim: t.tradeResponse?.trim,
      thumbnailUrl: t.tradeResponse?.thumb,
      year: t.tradeResponse?.year,
      vin: t.tradeResponse?.vin,
      topBid: t.tradeResponse?.topBid?.amount,
      bidPlacedTime: t.tradeResponse?.dateArrived,
      canUploadDigitalTitle: t.canUploadDigitalTitle,
      dealerProvince: t.tradeResponse?.dealer?.province,
      onHoldStatuses: [
        {
          value: t.titleMailToAddress,
          key: PostSaleLineItems.OWNERSHIP,
          status: t.titleStatus
        },
        {
          value: t.lienEmailToAddress,
          isEmail: true,
          key: PostSaleLineItems.LIEN_RELEASE,
          status: t.lienStatus === null ? 2 : t.lienStatus
        }
      ]
    }));
  }
}

export default TradeListPaymentsOnHold;
